// extracted by mini-css-extract-plugin
export var active = "_ir-2";
export var recordingDot = "_ir-1";
export var recordingIndicator = "_ir-0";